import React from 'react';

import { FormCategory, FormTextInput, FormInfo } from '../shared/FormElements';

import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

//import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';

export default function WarranteeEditInfoCard(props) {
  const rowData = props.rowData;
  const warranteeEditTitle = props.titleInfo;

  const singleInputRowHeight = 40;
  return (
    <Box sx={{ width: '100%' }}>
      <FormControl fullWidth>
        <Grid
          container
          rowSpacing={0}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
          style={{
            background: '#84a1bc91',
            padding: '5px 10px 5px 5px',
          }}
        >
          <Grid item xs={12} md={12}>
            <Typography variant='h5' sx={{ height: singleInputRowHeight }}>
              {warranteeEditTitle}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Card
              sx={{ boxShadow: 'none', border: 'none', background: 'none' }}
            >
              <Box sx={{ width: '100%' }}>
                <Grid
                  container
                  rowSpacing={0}
                  columnSpacing={{ xs: 2 }}
                  rowGap={0.2}
                >
                  <Grid item xs={12} md={6}>
                    <FormCategory title='Cabinet Typed:' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormCategory title='U-Save:' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormTextInput inputDefault='ACDC' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormTextInput inputDefault='1' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormCategory title='Shoprite:' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormCategory title='Shoprite Mini:' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormTextInput inputDefault='1' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormTextInput inputDefault='2' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormCategory title='Shoprite Liquor:' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormCategory title='Checkers:' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormTextInput inputDefault='1' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormTextInput inputDefault='1' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormCategory title='Spar:' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormCategory title='Game:' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormTextInput inputDefault='2' />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormTextInput inputDefault='3' />
                  </Grid>
                  <Grid item xs={12} md={6}></Grid>
                </Grid>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </FormControl>
    </Box>
  );
}
